export const createDisseminationLessonService =
  (fetch) => async (disseminationLesson) => {
    try {
      const formData = new FormData();
      formData.append("accident", disseminationLesson.accident);
      formData.append("file", disseminationLesson.lesson);

      const response = await fetch({
        url: "/api/v1/siniestros-viales/divulgacion-lecciones",
        method: "post",
        body: formData,
        contentType: "multipart/form-data",
      });

      return response;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  };
